import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropType from 'prop-types';
import AppStoreButton from '../../../components/AppStoreButton/AppStoreButton'

export class PartnerDetails extends PureComponent {

  render() {
    const { t, partner, isConnectButtonVisible } = this.props;
    
    // This url has to be absolute for a deep link to be opened
    const connectButtonHref = `${__BRAND__.meta.ogUrl}partners/${encodeURIComponent(partner.id)}/`;

    return (
      <div className="partner-details" id={partner.id}>
        <h1 className="partner-details-title title is-1">{partner.title}</h1>
        <img className="partner-details-icon" src={partner.icon}></img>
        {partner.subtitle &&
        <h3 className="partner-details-subtitle title">{partner.subtitle}</h3>
        }
        <p className="partner-details-text">{partner.text}</p>
        {isConnectButtonVisible && 
        <a className="button is-primary is-medium is-fullwidth is-uppercase" href={connectButtonHref} target="_blank">{t('CONNECT_WITH_SUUNTOAPP')}</a>
        }
        {!isConnectButtonVisible && 
        <div className="partner-details-apps">
          <p>Get the app to connect this service:</p>
          <AppStoreButton platform="ITUNES" className="partner-details-apps-button" />
          <AppStoreButton platform="PLAY" className="partner-details-apps-button" />
        </div>
        }
      </div>
    );
  }
}

PartnerDetails.defaultProps = {
  t: (str) => str,
  partner: null,
  isConnectButtonVisible: false,
};

PartnerDetails.propTypes = {
  t: PropType.func,
  partner: PropType.object.isRequired,
  isConnectButtonVisible: PropType.bool.isRequired,
};

export default translate()(PartnerDetails);
